import { atom } from "recoil";

export const appSettingAtom = atom({
  key: "appSettingRecoil",
  default: {
    claimStates: [],
    // weitere Einstellungen hier ergänzen
  },
});
